import { render, staticRenderFns } from "./MetricBlock.vue?vue&type=template&id=1df05dc6&scoped=true"
import script from "./MetricBlock.vue?vue&type=script&lang=js"
export * from "./MetricBlock.vue?vue&type=script&lang=js"
import style0 from "./MetricBlock.vue?vue&type=style&index=0&id=1df05dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df05dc6",
  null
  
)

export default component.exports